import { initElements, playVideo } from '../defs';

export default function initPageHeaders() {
    return initElements('.pheader', root => {

        initElements({
            root,
            selector: '.pheader-video',
        }, videoEl => {
            const container = videoEl.querySelector('.pheader-video-inner');
            videoEl.classList.add('is--initialized');
            playVideo(container, {
                videoId: videoEl.dataset.id,
                provider: videoEl.dataset.provider,
                background: true,
            });
        });
    });
}
